
export default {
  namespaced: true,
  state: () => ({
    ownerNames: {},
  }),
  mutations: {
    setDevices (state, devices) {
      state.ownerNames = devices.reduce((a, c) => { 
        if ((c.ownerName || '').length > 0) {
          a[c.device] = c.ownerName
        }
        return a
      }, {})
    }
  },
  getters: {
    owners (state) {
      return state.ownerNames
    }
  }
}